import { render } from "./addVoucher.vue?vue&type=template&id=5c2f4381&scoped=true"
import script from "./addVoucher.vue?vue&type=script&lang=js"
export * from "./addVoucher.vue?vue&type=script&lang=js"

import "./addVoucher.vue?vue&type=style&index=0&id=5c2f4381&lang=scss&scoped=true"
import "./addVoucher.vue?vue&type=style&index=1&id=5c2f4381&lang=css"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2f4381"]])

export default __exports__